import { Flex } from '@chakra-ui/react';
import EmailEditor, { EditorRef, EmailEditorProps } from 'react-email-editor'; // Importa il componente EmailEditor

const ModelEditor = ({ emailEditorRef, onLoad }:
    {
        emailEditorRef: React.RefObject<EditorRef>
        onLoad: EmailEditorProps["onLoad"]
    }) => {

    return (
        <Flex height={"75vh"}>
            <EmailEditor
                ref={emailEditorRef}
                onLoad={onLoad}
                options={{
                    locale: "it",
                    translations: {
                        'it-IT': {
                          "tools.tabs.content": "Contenuto",
                          "tools.tabs.row": "Riga",
                        }
                      }
                }}
            />
        </Flex>
    );
};

export default ModelEditor;